import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  tableFooter: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    paddingBottom: theme.spacing(2.75),
  },
  totalItems: {
    color: theme.palette.neutral.dark,
  },
  loadMoreButton: {
    padding: theme.spacing(2),
  },
}));

export default useStyles;
